import lurkerSend from './helper'

let pageName
let unloadListenerAlreadyDefined = false

export const lurkerPageLoadEvt = (optPage) => lurkerSend({
  event_type: 'page_view',
  object_detail: 'load',
  object_name: optPage ? optPage : pageName,
})

export const setPageName = (name, sendPageLoadEvent) => {
  const sendEvent = (typeof sendPageLoadEvent === 'boolean') ? sendPageLoadEvent : true
  pageName = name
  if (sendEvent) {
    lurkerPageLoadEvt()
  }
}

export const lurkerClickEvt = (detail, optPage, extraData) => lurkerSend({
  ...extraData,
  event_type: 'click',
  object_detail: detail,
  object_name: optPage ? optPage : pageName,
})

export const lurkerFillEvt = (detail, optPage) => lurkerSend({
  event_type: 'fill',
  object_detail: detail,
  object_name: optPage ? optPage : pageName,
})

export const lurkerErrorEvt = (detail, extraData) => lurkerSend({
  ...extraData,
  event_type: 'error',
  object_detail: detail,
  object_name: pageName,
})

export const lurkerViewMessageEvt = (detail, extraData, optPage) => lurkerSend({
  ...extraData,
  event_type: 'message_view',
  object_detail: detail,
  object_name: optPage ? optPage : pageName,
})

export const sendOnUnload = (payload) => {
  if (unloadListenerAlreadyDefined) return
  if (window.Lurker && window.Lurker.sendOnUnload) {
    window.Lurker.sendOnUnload(() => {
      return Object.assign(
        { event_type: 'page_leave', object_detail: 'unload' },
        typeof payload === 'function' ? payload() : payload
      )
    })
  } else {
    window.addEventListener('unload', function () {
      var _payload = typeof payload === 'function' ? payload() : payload
      console.log('LURKER UNLOAD EVENT: ', _payload)
    })
  }
  unloadListenerAlreadyDefined = true
}

const modules = {
  setPageName,
  sendOnUnload,
  lurkerPageLoadEvt,
  lurkerClickEvt,
  lurkerFillEvt,
  lurkerViewMessageEvt,
}

export default modules
